
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("kbezA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ForgeRequestCreatePropertyReactFragment", () => $cc0f640f00002709$export$a0a30379ac6516d);
$parcel$export(module.exports, "RequestCreatePropertyPanelModuleDumb", () => $cc0f640f00002709$export$5bc6d18550c44bba);
$parcel$export(module.exports, "RequestCreatePropertyPanel", () => $cc0f640f00002709$export$a8bb006880683518);
$parcel$export(module.exports, "default", () => $cc0f640f00002709$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $i7phc = parcelRequire("i7phc");

var $fKuli = parcelRequire("fKuli");

var $7UzY5 = parcelRequire("7UzY5");

var $5TkOb = parcelRequire("5TkOb");

var $cKOyj = parcelRequire("cKOyj");
parcelRequire("don2z");
var $iqMFl = parcelRequire("iqMFl");
parcelRequire("4AKYU");
var $inpZw = parcelRequire("inpZw");

var $ez1vp = parcelRequire("ez1vp");
const $cc0f640f00002709$export$a0a30379ac6516d = ({ extension: extension, extensionData: extensionData, onUpdate: onUpdate })=>{
    const submit = (payload)=>{
        const extId = extension.id.split('/');
        onUpdate({
            data: payload.data,
            extensionId: extId[1]
        });
        return true;
    };
    const getComponents = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((defaults)=>({
            ...defaults,
            ...(0, $ez1vp.requestCreatePropertyPanelUIKitComponents),
            [(0, $i7phc.TOP_LEVEL_COMPONENTS)[0, $i7phc.PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE]]: (0, $iqMFl.default)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        key: extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7UzY5.ExtensionProvider), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5TkOb.Renderer), {
        extension: extension,
        extensionData: extensionData,
        getComponents: getComponents,
        bridge: {
            submit: submit
        }
    })));
};
const $cc0f640f00002709$export$5bc6d18550c44bba = ({ extensions: extensions, portalId: portalId, requestTypeId: requestTypeId, onUpdateRequestPropertyData: onUpdateRequestPropertyData, showBanner: showBanner, resetBannerState: resetBannerState })=>{
    const extensionData = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>({
            type: (0, $i7phc.PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE),
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        }), [
        portalId,
        requestTypeId
    ]);
    const allowedExtensions = (0, $cKOyj.default)(extensions, (0, $i7phc.FORGE_REQUEST_CREATE), true, showBanner, resetBannerState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, allowedExtensions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fKuli.ExtensionPointProvider), {
        extensionType: (0, $i7phc.PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE)
    }, allowedExtensions.map((extension)=>extension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cc0f640f00002709$export$a0a30379ac6516d, {
            extension: extension,
            extensionData: extensionData,
            onUpdate: onUpdateRequestPropertyData,
            key: extension.id
        }))));
};
const $cc0f640f00002709$export$a8bb006880683518 = (0, $inpZw.withExtensionList)((0, $i7phc.PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE))($cc0f640f00002709$export$5bc6d18550c44bba);
var $cc0f640f00002709$export$2e2bcd8739ae039 = $cc0f640f00002709$export$a8bb006880683518;

});
parcelRegister("don2z", function(module, exports) {
$parcel$export(module.exports, "TopLevelComponent", () => (parcelRequire("iqMFl")).default);

var $iqMFl = parcelRequire("iqMFl");

});
parcelRegister("iqMFl", function(module, exports) {
$parcel$export(module.exports, "default", () => $910192f65985684c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $910192f65985684c$var$TopLevelComponent = ({ forgeDoc: forgeDoc, render: render })=>/*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, forgeDoc.children.map(render));
var $910192f65985684c$export$2e2bcd8739ae039 = $910192f65985684c$var$TopLevelComponent;

});


parcelRegister("4AKYU", function(module, exports) {
$parcel$export(module.exports, "withExtensionList", () => (parcelRequire("inpZw")).withExtensionList);

var $inpZw = parcelRequire("inpZw");

});
parcelRegister("inpZw", function(module, exports) {
$parcel$export(module.exports, "withExtensionList", () => $8986731486865644$export$15485afd16a49f87);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $i7phc = parcelRequire("i7phc");

var $9WNwm = parcelRequire("9WNwm");

var $jKkFd = parcelRequire("jKkFd");
const $8986731486865644$var$TrustedFetchExtensionComponent = ({ extensionType: extensionType, page: page, children: children, resourceId: resourceId, resourceType: resourceType, showBanner: showBanner, resetBannerState: resetBannerState })=>{
    const resourceContext = (0, $bSJIT.useMemo)(()=>({
            resourceId: resourceId,
            resourceType: resourceType
        }), [
        resourceId,
        resourceType
    ]);
    const { extensions: extensions } = (0, $jKkFd.useTFExtensionList)({
        resourceContext: resourceContext,
        page: page,
        type: extensionType
    });
    const childrenWithProps = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(children, {
        extensions: extensions,
        showBanner: showBanner,
        resetBannerState: resetBannerState
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, childrenWithProps);
};
const $8986731486865644$var$TrustedFetchComponentsWithBannerProps = (0, $egQxE.connect)(null, (0, $9WNwm.mapDispatchToPropsBanner))($8986731486865644$var$TrustedFetchExtensionComponent);
const $8986731486865644$export$15485afd16a49f87 = (type)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const extensionType = type || (props === null || props === void 0 ? void 0 : props.type);
            if (!extensionType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, {
                ...props,
                extensions: []
            });
            const { requestKey: requestKey, projectId: projectId, page: page } = props;
            let resourceType = (0, $i7phc.RESOURCE_TYPE_UNKNOWN);
            let resourceId;
            if (requestKey) {
                resourceType = (0, $i7phc.RESOURCE_TYPE_ISSUE);
                resourceId = requestKey;
            } else if (projectId) {
                resourceType = (0, $i7phc.RESOURCE_TYPE_PROJECT);
                resourceId = projectId.toString();
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($8986731486865644$var$TrustedFetchComponentsWithBannerProps, {
                extensionType: extensionType,
                resourceId: resourceId,
                resourceType: resourceType,
                page: page
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
        };

});


parcelRegister("ez1vp", function(module, exports) {
$parcel$export(module.exports, "requestCreatePropertyPanelUIKitComponents", () => $cdd9fb7cd03703cb$export$f59d1d69c7ff67d7);

var $heTFv = parcelRequire("heTFv");
const $cdd9fb7cd03703cb$export$f59d1d69c7ff67d7 = {
    PortalTextArea: $heTFv.PortalTextArea
};

});
parcelRegister("heTFv", function(module, exports) {
$parcel$export(module.exports, "PortalTextArea", () => $411b936b524bdda6$export$ee9c9301058468f8);

var $bSJIT = parcelRequire("bSJIT");

const $411b936b524bdda6$var$AKTextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("2MhP8")));
function $411b936b524bdda6$export$9080c693548e6787({ forgeDoc: forgeDoc, dispatch: dispatch }) {
    const { props: { name: name, isMonospaced: isMonospaced, placeholder: placeholder, spellCheck: spellCheck, onBlur: onBlur, value: value, appearance: appearance = 'standard', resize: resize = 'smart', minimumRows: minimumRows = 2 } = {} } = forgeDoc;
    const handleBlur = async (textValue)=>{
        if (onBlur) await dispatch({
            type: 'event',
            handler: onBlur,
            args: [
                textValue
            ],
            extensionData: {}
        });
    };
    return {
        akTextAreaProps: {
            name: name,
            appearance: appearance,
            resize: resize,
            minimumRows: minimumRows,
            isMonospaced: isMonospaced,
            placeholder: placeholder,
            spellCheck: spellCheck,
            value: value,
            // @typescript-eslint upgrade to v5.61.0
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onBlur: (event)=>handleBlur(event.target.value)
        }
    };
}
function $411b936b524bdda6$export$ee9c9301058468f8(props) {
    const { akTextAreaProps: akTextAreaProps } = $411b936b524bdda6$export$9080c693548e6787(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($411b936b524bdda6$var$AKTextArea, akTextAreaProps);
}

});
parcelRegister("2MhP8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iRhDT").then(()=>parcelRequire('9ZJMT'));

});





//# sourceMappingURL=forge-request-create-property-panel.7a793671.js.map
